import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/check-button/check-button.js';
      import {CheckButtonType, CheckButtonCheckboxAppearance} from '@oicl/openbridge-webcomponents/dist/components/check-button/check-button.js';

      export interface Props {
     type?: CheckButtonType;
     checked?: boolean;
     disabled?: boolean;
     fullWidth?: boolean;
     width?: string;
     showIcon?: boolean;
     hasCheckedIcon?: boolean;
     hasUncheckedIcon?: boolean;
     checkboxAppearance?: CheckButtonCheckboxAppearance
   }

      
  
      export type {CheckButtonType, CheckButtonCheckboxAppearance} from '@oicl/openbridge-webcomponents/dist/components/check-button/check-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcCheckButton',
  props: {
    type: {},
    checked: { type: Boolean },
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    width: {},
    showIcon: { type: Boolean },
    hasCheckedIcon: { type: Boolean },
    hasUncheckedIcon: { type: Boolean },
    checkboxAppearance: {}
  },
  emits: ["check-button-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onCheckButtonClick: (event: CustomEvent<{checked: boolean, type: string}>) => emit('check-button-click', event as CustomEvent<{checked: boolean, type: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-check-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})